import React from "react";
import LandingPage from "./components/LandingPage/LandingPage";

const App: React.FC = () => {
    return (
        <div className="App">
            <LandingPage />
        </div>
    );
};

export default App;